/**
 * VerificationType phone verification type
 */
export enum VerificationType {
  Sms = 'sms',
  Call = 'call'
}

/**
 * PhoneRequest model for phone verification request
 */
export class PhoneRequest {
  userId: number;
  phoneCode: number;
  phoneNumber: string;
  type: VerificationType;
}
